import { render, staticRenderFns } from "./InterestedCompanyCard.vue?vue&type=template&id=76fd522a&scoped=true&"
import script from "./InterestedCompanyCard.vue?vue&type=script&lang=js&"
export * from "./InterestedCompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./InterestedCompanyCard.vue?vue&type=style&index=0&id=76fd522a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd522a",
  null
  
)

export default component.exports